export default __webpack_public_path__ + "static/Drop-b04a800042f1dd900bb44f485aa1afa9.png";